// global
import React from 'react';
import PropTypes from 'prop-types';
// styles
import styles from './Snackbar.module.scss';

function Snackbar(props) {
  return (
    <div className={styles.snackbar}>
      <div className={styles.message}>{props.title}</div>

      {props.canClose && (
        <div className={styles.action} onClick={props.handleDismissSnackbar(props.id)}>
          OK
        </div>
      )}
    </div>
  );
}

Snackbar.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  canClose: PropTypes.bool,
  handleDismissSnackbar: PropTypes.func
};

export default Snackbar;
